import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class PrintPriceSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameimages: [0]
  }
    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.Delete_winnerImage = this.Delete_winnerImage.bind(this);
    this.Add_winnerImage=this.Add_winnerImage.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    //alert(event.target.name);
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }
  Delete_winnerImage(event){
     this.props.updateField({ [event.target.id]:-1 });
  }
    Add_winnerImage(event)
    {
      var img =document.getElementById("new_winner").value;
      this.props.updateField({
        [event.target.id]:img
      });
      document.getElementById("new_winner").value =null;
    }

  // #endregion
  render() {
    const { config } = this.props;
    console.log('PriceSettings');
    console.log(config);
    return (
      <Section title="Price settings">
        <FormGroup row className="d-flex justify-content-center">
        <Label for="templateId" sm={2}>
              Price (DT)
            </Label>
            <Col sm={10}>
              <Input
                value={config.printprice}
                type="Number"
                name="printprice"
                required
                id="printprice"
                onChange={this.handleChange}
              /> 
            </Col>            
        </FormGroup>
       
      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintPriceSetting);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/PrintPriceSetting.jsx